  const windowHeight = window.innerHeight;
  let lastScrollY = window.scrollY;

  // --- Helper function (if used by parallax) ---
  const getElementDocumentTop = (el) => {
    // ... (implementation from previous script)
    let S = 0;
    if (el.offsetParent) {
      while (el.offsetParent) {
        S += el.offsetTop;
        el = el.offsetParent;
      }
    } else if (el.y) {
      S += el.y;
    }
    return S;
  };

  // --- Get Elements ---
  const logoIcon = document.getElementById('logo-icon');
  const logoHolder = document.getElementById('logoholder');
  const socialNav = document.getElementById('socialNav');
  const socialNavTrigger = document.getElementById('logoholder'); // Or your specific #topLogoTrigger
  const scrollSpeedElements = document.querySelectorAll('.scrollSpeed');

// --- Parallax Setup (Modified) ---
const parallaxAnimations = [];
if (scrollSpeedElements.length > 0) {
    scrollSpeedElements.forEach(elem => {
        const triggerId = elem.dataset.trigger;
        const triggerElement = document.getElementById(triggerId);

        let fromProps, toProps;
        try {
            fromProps = JSON.parse(elem.dataset.from);
            toProps = JSON.parse(elem.dataset.to);
        } catch (e) {
            console.error("Error parsing data attributes for parallax:", e, elem);
            return;
        }

        if (!triggerElement) {
            console.warn(`Trigger element #${triggerId} not found for .scrollSpeed element:`, elem);
            return;
        }

        // MODIFICATION HERE: Use scrollStart and scrollEnd instead
        parallaxAnimations.push({
            elem,
            triggerElement,
            fromProps,
            toProps,
            scrollStart: -1, // Will be calculated on the first scroll event
            scrollEnd: -1,   // Will be calculated on the first scroll event
        });
    });
}

  // --- Define Animation Functions (accessible by onScroll) ---
  const playLogoIcon = () => {
    if (logoIcon) logoIcon.style.transform = 'rotate(0deg)';
  };
  const reverseLogoIcon = () => {
    if (logoIcon) logoIcon.style.transform = 'rotate(720deg)';
  };

  const playDesktopNav = () => {
    if (logoHolder) logoHolder.style.transform = 'translateY(0%)';
  };
  const reverseDesktopNav = () => {
    if (logoHolder) logoHolder.style.transform = 'translateY(-120%)';
  };

  const socialNavFromState = { xPercent: 0, top: 0 };
  const playSocialNav = () => {
    if (socialNav) {
      socialNav.style.transform = ''; // Or set to specific natural transform
      socialNav.style.top = '';       // Or set to specific natural top
    }
  };
  const reverseSocialNav = () => {
    if (socialNav) {
      socialNav.style.transform = `translateX(${socialNavFromState.xPercent}%)`;
      socialNav.style.top = `${socialNavFromState.top}px`;
    }
  };

  // --- Initial Styles & States ---
  if (logoIcon) {
    logoIcon.style.transform = 'rotate(0deg)';
    logoIcon.style.transition = 'transform 0.8s ease';
    if (window.scrollY > 0) {
      reverseLogoIcon();
    } else {
      playLogoIcon();
    }
  }

  if (logoHolder) {
    logoHolder.style.transform = 'translateY(0%)';
    logoHolder.style.transition = 'transform 0.2s ease';
    if (window.scrollY > 0) {
      reverseDesktopNav();
    } else {
      playDesktopNav();
    }
  }

  if (socialNav) {
    socialNav.style.transition = 'transform 0.2s ease, top 0.2s ease';
    playSocialNav(); // Set to initial natural state
  }

// --- Parallax Scroll Handler (Updated) ---
function handleParallaxScroll() {
    if (parallaxAnimations.length === 0) return;

    // We can get window height once here for efficiency
    const currentWindowHeight = window.innerHeight;

    parallaxAnimations.forEach(anim => {
        // Calculate animation boundaries on the first run (or on resize)
        if (anim.scrollStart === -1) {
            const triggerTop = getElementDocumentTop(anim.triggerElement);
            const triggerHeight = anim.triggerElement.offsetHeight;

            // Animation starts when the trigger's top hits the bottom of the viewport
            anim.scrollStart = triggerTop - currentWindowHeight;

            // Animation ends when the trigger's bottom hits the top of the viewport
            anim.scrollEnd = triggerTop + triggerHeight;
        }

        // If for some reason the calculation is not possible, skip
        if (anim.scrollStart === anim.scrollEnd) return;

        // Calculate the progress of the animation (0 to 1)
        const animationDistance = anim.scrollEnd - anim.scrollStart;
        const scrollRelativeToStart = window.scrollY - anim.scrollStart;
        let progress = scrollRelativeToStart / animationDistance;

        // Clamp the progress value between 0 and 1
        progress = Math.min(1, Math.max(0, progress));

        // The rest of your code remains the same!
        let transformString = "";
        Object.keys(anim.toProps).forEach(key => {
            const fromValue = parseFloat(anim.fromProps[key] || (key === 'opacity' || key === 'scale' ? 1 : 0));
            const toValue = parseFloat(anim.toProps[key]);
            const currentValue = fromValue + (toValue - fromValue) * progress;

            if (key === 'opacity') {
                anim.elem.style.opacity = currentValue;
            } else if (key === 'yPercent') {
                transformString += ` translateY(${currentValue}%)`;
            } else if (key === 'xPercent') {
                transformString += ` translateX(${currentValue}%)`;
            } else if (key === 'scale') {
                transformString += ` scale(${currentValue})`;
            } else if (key === 'rotate') {
                transformString += ` rotate(${currentValue}deg)`;
            }
        });

        anim.elem.style.transform = transformString.trim();
    });
}


  // --- Main Scroll Handler ---
  function onScroll() {
    const currentScrollY = window.scrollY;
    const direction = currentScrollY > lastScrollY ? 1 : (currentScrollY < lastScrollY ? -1 : 0);

    if (parallaxAnimations.length > 0) {
        requestAnimationFrame(handleParallaxScroll);
    }

    if (logoIcon) {
      if (currentScrollY === 0) {
        playLogoIcon();
      } else if (direction === -1) {
        playLogoIcon();
      } else if (direction === 1) {
        reverseLogoIcon();
      }
    }

    if (logoHolder) {
      if (currentScrollY === 0) {
        playDesktopNav();
      } else if (direction === -1) {
        playDesktopNav();
      } else if (direction === 1) {
        reverseDesktopNav();
      }
    }

    if (socialNav && socialNavTrigger) {
      if (direction === -1) {
        playSocialNav();
      } else if (direction === 1) {
        reverseSocialNav();
      }
      if (currentScrollY === 0 && direction !== 1) {
        playSocialNav();
      }
    }

    lastScrollY = currentScrollY <= 0 ? 0 : currentScrollY;
  }

  window.addEventListener('scroll', onScroll, { passive: true }); // Added passive true for better scroll performance

  // Initial call to set states based on load position
  onScroll();
  if (parallaxAnimations.length > 0) {
    handleParallaxScroll(); // Initial call for parallax
  }